import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * API технических устройств, находящихся на объектах
 */
@Injectable()
export class TechnicalDeviceApiService extends ApiService {
    baseUrl = 'technical-device';

    /**
     * Путь для получения типов технических устройств
     * @param objectId
     */
    getTechnicalDeviceTypesPath(objectId: number): string {
        return `technical-device-type/selector?object_id=${objectId}`;
    }

    /**
     * Путь для смены статуса технического устройства
     * @TODO Подумать над именованием, когда только POST, только GET, только POST и GET и когда POST, GET, DELETE запросы
     * @param deviceId
     */
    getSetStatusUrl(deviceId: number): string {
        return `${this.baseUrl}/${deviceId}/set-status`;
    }

    /**
     * Путь для создания с привязкой и редактирования группы элементов (типоразмера элемента)
     * @param deviceId
     */
    getElementsGroupsPath(deviceId: number) {
        return `${this.baseUrl}/${deviceId}/element-group`;
    }

    /**
     * Путь для получения статистической информации по техническому устройству:
     * Сколько элементов в плане, сколько выдано заключений, в каких статусах и т.п.
     * @param deviceId
     */
    getSummaryInfoPath(deviceId: number) {
        return `${this.baseUrl}/${deviceId}/summary-info`;
    }

    /**
     * Путь для получения динамических параметров групп элементов для заполнения формы
     * @param deviceId
     */
    getElementsGroupsParamsPath(deviceId: number) {
        return `${this.baseUrl}/${deviceId}/element-group-params`;
    }

    /**
     * Путь для получения доступных типоразмеров для формы элементов технического устройства
     * @param deviceId
     * @param ntdId
     */
    getElementsGroupTypesPath(deviceId: number, ntdId: number) {
        return `${this.baseUrl}/${deviceId}/element-types?ntd_id=${ntdId}`;
    }

    /**
     * Путь для создания и связывания документации с техническим устройством
     * @param deviceId
     */
    getDocumentPath(deviceId: number) {
        return `${this.baseUrl}/${deviceId}/document`;
    }

    /**
     * Путь для получения списка доступных для выбора НТД при создании группы элементов
     */
    getStandardTechnicalDocumentsPath(deviceId: number) {
        return `${this.baseUrl}/${deviceId}/standard-technical-document`;
    }

    /**
     * Путь для получения списка динамических параметров НТД для формы группы элементов
     */
    getStandardTechnicalDocumentParamsPath(deviceId: number, ntdId: number) {
        return `${this.getStandardTechnicalDocumentsPath(deviceId)}/${ntdId}/params`;
    }

    /**
     * Путь для списка доступных для выбора объектов контроля
     */
    getObjectsPath() {
        return `${this.baseUrl}/objects`;
    }
}
